"use client";

import { css } from 'styled-components';
import { whenDisabled, whenFocused, whenHovered, whenPressed } from 'utils';
import { theme } from '@frameio/vapor-theme';
import type { ButtonColor } from './types';

type VariantProps = {
  disabled: boolean;
  $color: ButtonColor;
};

const {
  primary: buttonPrimary,
  destructive: buttonDestructive,
  secondary: buttonSecondary,
} = theme.colors.components.button;

export function ghostVariant() {
  return css<any>`
    ${baseStyles};

    ${whenHovered} {
      ${((p: any) => !p.$sharedHoverEnabled && hoverStyles) as any};
    }

    ${whenFocused} {
      ${focusStyles};
    }

    &[aria-expanded='true'] {
      ${((p: any) => !p.$sharedHoverEnabled && hoverStyles) as any};
      ${activeStyles};
    }

    ${whenPressed} {
      ${activeStyles};
    }

    ${whenDisabled} {
      background-color: transparent;
      color: ${theme.colors.text.interactive.disabled};
      pointer-events: none;
    }
  `;
}

function baseStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      background-color: transparent;
      color: ${buttonPrimary.background};
    `;
  }

  if (p.$color === 'error') {
    return css`
      background-color: transparent;
      color: ${theme.colors.text.interactive.error};
    `;
  }

  if (p.$color === 'neutral') {
    return css`
      background-color: transparent;
      color: ${theme.colors.text.secondaryStark};
    `;
  }

  return css`
    background-color: transparent;
    color: ${buttonSecondary.icon};
  `;
}

function hoverStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      background-color: ${theme.colors.brand.primaryAlphaLow};
      color: ${theme.colors.brand.primary};
    `;
  }

  if (p.$color === 'error') {
    return css`
      background-color: ${buttonDestructive.interactive.background
        .hoverOpacity};
      color: ${theme.colors.text.interactive.error};
    `;
  }

  if (p.$color === 'neutral') {
    return css`
      background-color: ${theme.colors.background.interactive.offStark};
      color: ${theme.colors.text.secondaryStark};
    `;
  }

  return css`
    background-color: ${buttonSecondary.interactive.background.hover};
    color: ${buttonSecondary.icon};
  `;
}

function focusStyles(p: VariantProps) {
  return hoverStyles(p);
}

function activeStyles(p: VariantProps) {
  if (p.$color === 'primary') {
    return css`
      background-color: ${theme.colors.brand.primaryAlphaLow};
    `;
  }

  if (p.$color === 'error') {
    return css`
      background-color: ${theme.colors.background.interactive.error};
    `;
  }

  return css``;
}
